export default {
    items: {
        data: null
    },
    fotos: {
        data: null
    }
}